import * as geometric from 'geometric'

import { ConnectionI, DeviceI } from '../types/types'

export const mapDevicesData = (devices: DeviceI[]) => {
  return devices
    .filter((device) => device.placed)
    .map((device) => ({
      ...device,
      projectedX: device.x,
      projectedY: device.y,
    }))
}

export const mapCheckpointData = (devices: DeviceI[], floorId: string) => {
  return devices
    .filter((device) => device.placed && device.checkpoint.floor.id === floorId)
    .map((device) => ({
      ...device,
      projectedX: device.x,
      projectedY: device.y,
    }))
}

export const mapConnectionsData = (connections: ConnectionI[]) => {
  if (connections.length === 0) return []
  return connections.map((item) => {
    const {
      id,
      cameraId,
      deviceId,
      deviceType,
      lineCoords,
      isConnected,
      isTailgateGridConfigured,
      isTailgateEnabled,
    } = item
    const [midX, midY] = geometric.lineMidpoint(lineCoords as geometric.Line)
    return {
      id,
      deviceId,
      cameraId,
      deviceType,
      midX,
      midY,
      lineCoords,
      isConnected,
      isTailgateGridConfigured,
      isTailgateEnabled,
    }
  })
}
